/**
 * Formats a date based on the given local according to our usually used date formats at Blinkist.
 *
 * @param date A JS date object.
 * @param locale The locale either "de" or "en".
 * @returns {string} The formatted date string.
 */
export default function (date, locale) {
  const month = (date.getMonth() + 1).toString().padStart(2, "0") // +1 because getMonth returns the month 0 based. (0 = January)
  const day = date.getDate().toString().padStart(2, "0")
  if (locale === "de") {
    return `${day}.${month}.${date.getFullYear()}`
  } else {
    return `${date.getFullYear()}-${month}-${day}`
  }
}
